import {useCallback, useState} from 'react'

import type {CopilotChatRepo} from '../utils/copilot-chat-types'
import {copilotLocalStorage} from '../utils/copilot-local-storage'

export type UseLastUsedRepositoryReturn = [
  lastUsedRepo: CopilotChatRepo | null,
  setLastUsedRepo: (repo: CopilotChatRepo | null) => void,
]

/**
 * Custom hook that manages the last used repository state and automatically
 * loads it from local storage on mount.
 */
export function useLastUsedRepository(): UseLastUsedRepositoryReturn {
  const [lastUsedRepo, setLastUsedRepo] = useState<CopilotChatRepo | null>(() => {
    return copilotLocalStorage.getLastUsedRepository()
  })

  const setRepo = useCallback((repo: CopilotChatRepo | null) => {
    setLastUsedRepo(repo)
    if (repo) {
      copilotLocalStorage.setLastUsedRepository(repo)
    }
  }, [])

  return [lastUsedRepo, setRepo]
}
